import { render, staticRenderFns } from "./Jobs.vue?vue&type=template&id=0bf28682&scoped=true"
import script from "./Jobs.vue?vue&type=script&lang=js"
export * from "./Jobs.vue?vue&type=script&lang=js"
import style0 from "./Jobs.vue?vue&type=style&index=0&id=0bf28682&prod&scoped=true&lang=css"
import style1 from "./Jobs.vue?vue&type=style&index=1&id=0bf28682&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf28682",
  null
  
)

export default component.exports